import { Flex, Image } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';
import PremiumBadge from '../../../../images/premium-badge.png';

interface Props {
  isPremiumListing: boolean;
  headingText: string;
}

export function ListingModuleHeading({ isPremiumListing, headingText }: Props) {
  return (
    <Flex display="flex" flex-direction="row" alignItems="center">
      {isPremiumListing && <Image src={PremiumBadge} alt="premium badge" width={35} />}
      <Text
        className="ConnectedCard-Heading"
        asChild
        css={{
          marginRight: { base: '200', lg: '400' },
          textStyle: { base: 'body-bold', lg: 'heading-xs' },
        }}
      >
        <h2>{headingText}</h2>
      </Text>
    </Flex>
  );
}
